import { render, staticRenderFns } from "./ApnSifap.vue?vue&type=template&id=478ace23&lang=pug"
import script from "./ApnSifap.vue?vue&type=script&lang=js"
export * from "./ApnSifap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports